<template>
  <div class="code" :style="{ backgroundImage: `url(${bgImage})` }">
    <Header :isShow="false"></Header>
    <div class="bg">
      <div class="code-box" v-loading="bgLoading" element-loading-background="rgba(255, 255, 255, 0.5)">
        <div class="top-title leftW" :style="{ color: topTitleColor }">
          Check your phone
        </div>
        <div class="title-desc leftW" :style="{ color: secondTitleColor }">
          A 6-digit code was sent to +{{ curCountryCode }} {{ phone }}, enter it
          within 10 minutes. Didn't get it? Try resending the code.
        </div>
        <!-- :id="'captcha' + index" -->
        <div class="code-main">
          <input
            v-for="(item, index) in captchas"
            :key="index"
            v-model="item.num"
            :id="'captcha' + index"
            :ref="'input' + index"
            @input="inputFinash(index)"
            @focus="adjust(index)"
            @keydown="inputDirection(index)"
            @keyup.enter="inputFinash(index)"
            class="captcha_input_box row-center"
            type="tel"
            maxlength="1"
          />
        </div>
        <div
          class="bottom leftW"
          :style="{
            color: color,
          }"
          @click="resendDo"
        >
          {{ resendCode }}
        </div>
      </div>
    </div>
    <!-- <el-dialog
        class="dialog"
        title=""
        v-model="centerDialogVisible"
        width="30%"
        center
      >
        <div class="dialog-top">
          <img src="@/assets/icon-notice.png" />
          <div class="dialog-top-title">Notice</div>
        </div>
        <div class="dialog-middle">
          <div class="dialog-middle-one">
            {{dialogTopStr}}
          </div>
          <div class="dialog-middle-two">
            {{dialogBottomStr}}
          </div>
        </div>
        <div class="dialog-bottom">
          <el-button class="dialog-bottom-btn" @click="cancelDialog"
            >OK</el-button
          >
        </div>
      </el-dialog> -->
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
// import { ElMessage } from 'element-plus'
import { getCodeDown, removeCodeDown, setCodeDown } from "@/utils/Setitem";
// import sha256 from "js-sha256";
import { isDayTime } from "@/utils/common";
import nightImage from "@/assets/night-bg-img.jpg";
import dayTimeImage from "@/assets/daytime-bg-img.jpg";
let interval;

import {
  createCaptcha,
  errorMessageMap,
  getUserById,
  login,
} from "@/request/api";

export default {
  name: "code",
  props: {
    codeLength: {
      default: 6,
      type: Number,
    },
  },
  data() {
    return {
      phone: "",
      curCountryCode: "",
      codeList: [],
      code: "",
      // 当前输入框
      activeInput: 0,
      captchas: [
        { num: "" },
        { num: "" },
        { num: "" },
        { num: "" },
        { num: "" },
        { num: "" },
      ],
      timer: null,
      count: "",
      centerDialogVisible: false,
      color: "#999999",
      resendCode: "",
      TIME_COUNT: 60,
      dialogTopStr: "",
      dialogBottomStr: "",
      topTitleColor: "#000000",
      secondTitleColor: "#565656",
      bgLoading: false,
      bgImage: null,
    };
  },
  watch: {
    // 截取字符长度
    code() {
      if (this.code.length > this.codeLength) {
        this.code = this.code.substring(0, this.codeLength);
      }
    },
  },
  methods: {
    cancelDialog() {
      this.centerDialogVisible = false;
    },
    async resendDo() {
      if (this.count <= 0) {
        try {
          this.bgLoading = true;
          await createCaptcha(this.phone, this.curCountryCode);
          this.$message.success("sent successfully");
          const endMs = new Date().getTime() + 60000;
          setCodeDown(endMs);
          let myEndTime = getCodeDown();
          this.getCode(myEndTime);
          this.bgLoading = false;
        } catch (e) {
          this.bgLoading = false;
          const message = e.message;
          let msg = "get validation failed"
          if (message.includes("errorId:")) {
            const errorId = message.split("errorId:").pop();
            if (errorId) {
              msg = errorMessageMap.get(errorId) || msg;
            }
          } else {
            msg = errorMessageMap.get(message) || msg;
          }
          this.$message.warning(msg); 
        }
      }
    },
    async login() {
      this.bgLoading = true;
      let captcha = "";
      this.captchas.forEach((value) => {
        captcha += value.num;
      });
      try {
        const data = await login(captcha);
        this.$cookies.set("token", data.token);
        const userInfo = await getUserById();
        console.log("getUserById =  ", userInfo);
        this.$message.success("login succeeded");
        this.bgLoading = false;
        if (userInfo.user?.nickname) {
          this.$router.replace({ name: "Home" })
        } else {
          this.$router.replace({ name: "InfoPage" })
        }
      } catch (e) {
        this.bgLoading = false;
        this.captchas.forEach((value) => {
          value.num = "";
        });
        let dom = document.getElementById("captcha" + 0);
        dom?.focus();

        console.log("createAuth e = ", e);
        const message = e.message;
        if (message.includes("errorId:")) {
          const errorId = message.split("errorId:").pop();
          if (errorId) {
            this.dialogTopStr = errorMessageMap.get(errorId) || message;
          }
        } else {
          this.dialogTopStr = errorMessageMap.get(message) || message;
        }
        this.centerDialogVisible = true;
      }
    },
    getCode(endMsRes) {
      if (!this.timer) {
        this.count = Math.ceil((endMsRes - new Date().getTime()) / 1000);
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            const isDay = isDayTime();
            if (isDay) {
              this.color = "#999999";
            } else {
              this.color = "#EEEEEE";
            }
            this.count--;
            this.resendCode = `Resend in ${this.count}s`;
          } else {
            this.color = "#0050B3";
            this.resendCode = "Resend code";
            this.show = true;
            removeCodeDown();
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 自动校准输入顺序
    adjust(index) {
      let dom = document.getElementById("captcha" + this.activeInput);
      if (index !== this.activeInput && dom) {
        dom?.focus();
      }
      console.log("captchas = ", this.captchas);
    },

    // 控制前后方向
    inputDirection(index) {
      let val = this.captchas[index].num;
      // 回退键处理
      if (event.keyCode == 8 && val == "") {
        // 重新校准
        let dom = document.getElementById("captcha" + (index - 1));
        this.activeInput = index - 1;
        if (dom) dom?.focus();
      }
      if (event.keyCode != 8 && val != "") {
        let dom = document.getElementById("captcha" + (index + 1));
        this.activeInput = index + 1;
        if (dom) dom?.focus();
      }
      console.log("captchas = ", this.captchas);
    },

    // 输入框相互联动
    async inputFinash(index) {
      let val = this.captchas[index].num;
      this.activeInput = val ? index + 1 : index - 1;
      let dom = document.getElementById("captcha" + this.activeInput);
      if (dom) dom?.focus();
      if (index == this.captchas.length - 1) {
        let code = this.captchas.map((x) => x.num).join("");
        if (code.length == 6) {
          this.login();
        }
      }
      console.log("captchas = ", this.captchas);
    },
  },
  mounted() {
    // 定义一个数组用于循环
    this.codeList = new Array(this.codeLength).fill("");
    let dom = document.getElementById("captcha" + 0);
    if (dom) dom?.focus();
  },
  beforeUnmount() {
    clearInterval(interval);
  },
  created() {
    this.phone = this.$route.params.phone;
    this.curCountryCode = this.$route.params.countryCode;
    let myEndTime = getCodeDown();
    this.getCode(myEndTime);
    console.log("captchas = ", this.captchas);
  },
  beforeCreate() {
    interval = setInterval(() => {
      const isDay = isDayTime();
      if (isDay) {
        this.bgImage = dayTimeImage;
        this.topTitleColor = "#000000";
        this.secondTitleColor = "#565656";
      } else {
        this.bgImage = nightImage;
        this.topTitleColor = "#ffffff";
        this.secondTitleColor = "#EEEEEE";
      }
    }, 100);
  },
  components: {
    Header,
  },
};
</script>

<style lang='less' scoped>
.code {
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: 100% 100%;
}
.bg {
  // height: calc(100% - 102px);
  margin: 0 auto;
  display: flex;
  // align-items: center;
  margin-left: 300px;
  margin-top: 5%;//90px;
}
.code-box {
  width: 550px;
  background-color: #fff;
  border: 0px solid #707070;
  border-radius: 6px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 30px 0px 150px 0px;
}
.leftW {
  margin-left: 38px;
}
.top-title {
  color: #000000;
  font-weight: 900;
  font-size: 32px;
  text-align: left;
  padding-top: 20px;
}
.title-desc {
  color: #565656;
  font-size: 17px;
  text-align: left;
  margin-top: 10px;
  font-weight: 400;
  padding-right: 30px;
}

.code-main {
  display: flex;
  flex-direction: row;
  margin-left: 33px;
  width: 500px;
  justify-content: space-between;
  margin-top: 30px;
}

.captcha_input_box {
  width: 50px; //11.2vw;
  height: 50px;
  margin-right: 9px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  border: 1px solid #dddddd;
  font-size: 20px;
  text-align: center;
  color: #1e243a;
}

.code-input-input {
  height: 44px;
  width: 100%;
  position: absolute;
  border: none;
  outline: none;
  color: transparent;
  background-color: transparent;
  text-shadow: 0 0 0 transparent;
}

.bottom {
  text-align: left;
  margin-top: 10px;
  color: #999999;
  font-size: 17px;
  cursor: pointer; 
}
</style>